
import axios from "axios";


   import {apiUrl} from '../AxiosAPI' ;  

  // SignUp API post call with rest endpoint 
   export const getAllProductsByAppForClients = (data) => axios.post(`${apiUrl}/getAllProductsByAppForClients`,data);  
  export const handleEnrollmentActionsByClientsAPI = (data) => axios.post(`${apiUrl}/handleEnrollmentActionsByClientsAPI`,data);  
 export const handleEnrollmentsFilterByUser = (data) => axios.post(`${apiUrl}/handleEnrollmentsFilterByUser`,data);  
export const getSubCoursesClientByCourseId = (data) => axios.post(`${apiUrl}/getSubCoursesClientByCourseId`,data);  
export const getMilestonesClientsBySubCourse = (data) => axios.post(`${apiUrl}/getMilestonesClientsBySubCourse`,data);  
export const getSectionsClientByMilestone = (data) => axios.post(`${apiUrl}/getSectionsClientByMilestone`,data);  
export const getContentsClientBySection = (data) => axios.post(`${apiUrl}/getContentsClientBySection`,data);  
export const getContentsClientByFolder = (data) => axios.post(`${apiUrl}/getContentsClientByFolder`,data);  
export const getContentsClientByChapter = (data) => axios.post(`${apiUrl}/getContentsClientByChapter`,data);  
 